export const privateRoutes = {
  dashboard: "/dashboard",
  Pricing: "/pricing/plans",
  userManagementRoles: "/user-management/roles",
  userManagementUsers: "/user-management/users",
  userManagementPermissions: "/user-management/permissions",
  productSubscription: "/product-subscription",
  billingPayment: "/billing-payment",
  auth: "/auth/*",
  companyManagementProfile: "/company-management/profile",
  companyManagementServices: "/company-management/services",
  companyManagementRebranding: "/company-management/rebranding",
  companyManagementPreferences: "/company-management/preferences",
  companyManagementIntegrations: "/company-management/integrations",
  companyManagementLegal: "/company-management/legal",
  companyManagementCompanyBranches: "/company-management/company-branches",
  myProfile: "/my-profile",
  fillCompanyDetails: "/fill-company-details",
  helpSupport: "/help-support",
  report: "/report",
  pricingComparison: "/pricing-comparison",
  subscriptionUsage: "/pricing/subscription-usage",
  paymentProcess: "/pricing/plans/payment",
  emailNotVerified: "/email-not-verified",
  notAuthorized: "/not-authorized",
};

export const privateRoutesArray: string[] = (
  Object.keys(privateRoutes) as Array<keyof typeof privateRoutes>
).map((key) => privateRoutes[key]);
